<template>
    <div class="maintena-page">
        <div class="head-line"></div>
        <div class="icon-wrapper">
            <img class="icon-chanel" src="../../../assets/icon/white@3x.png" />
        </div>
        <div class="content-wrapper">
            <div class="content">
                <div class="title">{{lbl.maintena.title}}</div>
                <div class="text" v-html="lbl.maintena.text"></div>
                <div class="btn btn-continue" @click="openlink()">{{lbl.maintena.btn_text}}</div>
            </div>
        </div>
    </div>
</template>
<script>

import Locale from "@/helper/locale/locale.js";
export default {

    name: "LoginLine",
    data: function() {
        return {
            lbl: Locale.getLbl(),
        }

    },
    created: function() {


    },
    methods: {
        openlink:function () {
            window.open("https://www.chanel.com/th/fragrance/");
        }
    },
}

</script>
<style lang="scss" scoped>
.maintena-page {
    height: 100vh;
    background-color: white;
    .head-line {
        height: 5px;
        background-color: black;
    }
    .icon-wrapper {
        text-align: center;
        .icon-chanel {
            margin-top: 42px;
            height: 26px;
            width: auto;
        }
    }

    .content-wrapper{
        height: calc(100% - 75px);
        display: flex;
        flex-direction: column;
        margin: auto;

        .content {
            margin: auto;
            text-align: center;
            padding: 27px;

            .title {
                font-size: 18px;
                margin-bottom: 20px;
            }
            .text {
                font-size: 14px;
                margin-bottom: 20px;
            }
            .btn-continue {
                background-color: #FFFFFF;
                border: 1px solid #000;
                color: #000000;
                border-radius: 0;
                font-size: 14px;
                height: 40px;
                line-height: 2;
            }
        }
    }
}
</style>
